import { createApp } from 'vue'
import App from './App.vue'
import './app.css'
import './registerServiceWorker'

createApp(App).mount('#app')
